import React, { useEffect } from "react";
import ContactHeroImage from "../images/Farah_Siraj-Photo_by_Yasmina_Barbero_4[optimized].jpg";
import ContactForm from "./ContactForm";
import useImageLoader from "../custom_hooks/imageLoader";
import Loader from "./Loader";
import Footer from "./Footer";
import "../css/Contact.css";

export default function Contact() {
  const imageArray = [ContactHeroImage];
  const allImagesLoaded = useImageLoader(imageArray);

  useEffect(() => {
    if (allImagesLoaded) {
      const contactHero = document.querySelector(".contact-hero");
      if (contactHero) {
        contactHero.style.backgroundImage = `url(${ContactHeroImage})`;
      }
    }
  }, [allImagesLoaded]);

  if (!allImagesLoaded) {
    return (
      <div>
        <Loader loaded={false} />
      </div>
    );
  }

  return (
    <div className="contact-body">
      <Loader loaded />

      <div className="contact-hero" />
      <h1>Contact</h1>

      {/* Mailchimp signup */}
      <div id="mc_embed_signup" style={{ maxWidth: 600 }}>
        <form
          action="https://farahsiraj.us6.list-manage.com/subscribe/post?u=a677e60a102dbf7ffeca77cad&amp;id=244c089926&amp;f_id=00ff1ee2f0"
          method="post"
          id="mc-embedded-subscribe-form"
          name="mc-embedded-subscribe-form"
          target="_blank"
          rel="noreferrer"
          noValidate
        >
          <div id="mc_embed_signup_scroll">
            <h2>Subscribe to Farah&apos;s Newsletter</h2>

            <div className="indicates-required">
              <span className="asterisk">*</span> indicates required
            </div>

            <div className="mc-field-group">
              <label htmlFor="mce-EMAIL">
                Email Address <span className="asterisk">*</span>
              </label>
              <input
                type="email"
                name="EMAIL"
                className="required email"
                id="mce-EMAIL"
                required
                defaultValue=""
              />
            </div>

            <div id="mce-responses" className="clear foot">
              <div
                className="response"
                id="mce-error-response"
                style={{ display: "none" }}
              />
              <div
                className="response"
                id="mce-success-response"
                style={{ display: "none" }}
              />
            </div>

            {/* Bot trap (honeypot) */}
            <div aria-hidden="true" style={{ position: "absolute", left: "-5000px" }}>
              <input
                type="text"
                name="b_a677e60a102dbf7ffeca77cad_244c089926"
                tabIndex={-1}
                defaultValue=""
              />
            </div>

            <div className="optionalParent">
              <div className="clear foot">
                <input
                  type="submit"
                  name="subscribe"
                  id="mc-embedded-subscribe"
                  className="button"
                  value="Subscribe"
                />

                <p style={{ margin: "0 auto" }}>
                  <a
                    href="https://eepurl.com/jxBrYE"
                    title="Mailchimp - email marketing made easy and fun"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span
                      style={{
                        display: "inline-block",
                        backgroundColor: "transparent",
                        borderRadius: 4,
                      }}
                    >
                      <img
                        className="refferal_badge"
                        src="https://digitalasset.intuit.com/render/content/dam/intuit/mc-fe/en_us/images/intuit-mc-rewards-text-dark.svg"
                        alt="Intuit Mailchimp"
                        style={{
                          width: 220,
                          height: 40,
                          display: "block",
                          padding: "2px 0",
                        }}
                      />
                    </span>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div className="form-container">
        <ContactForm />
      </div>

      <Footer />
    </div>
  );
}